import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useEffect } from 'react';
import Box from '../../Box/index.esm.js';
import Transition from '../../Transition/index.esm.js';
import { getYear } from 'date-fns';
import { FROM_YEAR } from '../constants.esm.js';
import PickerContent from './PickerContent.esm.js';
import PickerHeader from './PickerHeader.esm.js';

var PickerOverlay = function PickerOverlay(_ref) {
  var calendarState = _ref.calendarState,
      setCalendarState = _ref.setCalendarState,
      monthYear = _ref.monthYear,
      setMonthYear = _ref.setMonthYear,
      headerHeight = _ref.headerHeight,
      contentHeight = _ref.contentHeight,
      size = _ref.size;

  var _useState = useState(Math.floor((getYear(monthYear) - FROM_YEAR) / 12)),
      page = _useState[0],
      setPage = _useState[1];

  var _useState2 = useState(getYear(monthYear)),
      displayYear = _useState2[0],
      setDisplayYear = _useState2[1];

  var _useState3 = useState(calendarState),
      oldState = _useState3[0],
      setOldState = _useState3[1];

  useEffect(function () {
    setPage(Math.floor((getYear(monthYear) - FROM_YEAR) / 12));
    setDisplayYear(getYear(monthYear));
  }, [monthYear]);
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(PickerHeader, _extends({}, {
    calendarState: calendarState,
    setCalendarState: setCalendarState,
    monthYear: monthYear,
    setMonthYear: setMonthYear,
    headerHeight: headerHeight,
    size: size,
    page: page,
    setPage: setPage,
    displayYear: displayYear,
    setDisplayYear: setDisplayYear
  })), React__default.createElement(Transition, {
    show: calendarState !== 'DAY',
    enter: ['ease-out', 'duration-200'],
    enterFrom: ['opacity-0', 'scale-125'],
    enterTo: ['opacity-100', 'scale-100'],
    leave: ['ease-out', 'duration-200'],
    leaveFrom: ['opacity-100', 'scale-100'],
    leaveTo: ['opacity-0', 'scale-125'],
    onEnter: function onEnter() {
      return setOldState(calendarState);
    },
    onExited: function onExited() {
      return setOldState(calendarState);
    }
  }, React__default.createElement(Box, {
    position: "absolute",
    inset: "top-0",
    zIndex: "z-40",
    width: "w-full",
    backgroundColor: "bg-white",
    transitionProperty: "transition-all",
    transform: "transform",
    style: {
      top: headerHeight,
      height: contentHeight
    }
  }, React__default.createElement(PickerContent, _extends({}, {
    setCalendarState: setCalendarState,
    monthYear: monthYear,
    setMonthYear: setMonthYear,
    size: size,
    page: page,
    displayYear: displayYear,
    oldState: oldState
  })))));
};

export default PickerOverlay;
//# sourceMappingURL=PickerOverlay.esm.js.map
